import vsComponent from './vsButton'

export default Vue => {
  Vue.component(vsComponent.name, vsComponent)
}
